import React from 'react';
import styled from 'styled-components';

import { useOptionContext } from './option-context';

/** Bold current price for an option tile. */
export function TilePrice(): JSX.Element {
  const { currentPrice } = useOptionContext();

  return <Price>{currentPrice}</Price>;
}

const Price = styled.b`
  color: var(--cms-color, inherit);
  display: block;
  font-size: var(--cms-font-size, 16px);
  font-weight: var(--cms-font-weight, 600);
  line-height: ${18 / 16};

  @media screen and (min-width: 740px) {
    font-size: var(--cms-font-size, 14px);
  }
`;
